<template >
  <VotationDetail v-if="owners_association" :owners_association="owners_association" :votation="votation" :img-no="imgNo" :is-loading="isLoading" :no_votation="no_votation"></VotationDetail>
</template>

<script>
import VotationDetail from '@/components/VotationDetail/VotationDetail';

export default {

  props: ['id'],

  components: {
    VotationDetail,
  },
  created() {
    this.loadVotationInfo();
  },
  computed: {
    no_votation() {
      return !this.isLoading;
    },
    owners_association() {
      return this.$store.getters.ownersAssociation;
    },
  },
  methods: {
    async loadVotationInfo() {
      try {
        let idVotacion;
        if (process.env.VUE_APP_MODE === 'web') idVotacion = this.$route.params.id;
        else idVotacion = this.id;
        this.votation = await this.getVotationDetail(this.owners_association.id, idVotacion);

        this.isLoading = false;
      } catch (err) {
        this.imgNo = true;
        this.isLoading = false;

        // console.log(err);
      }
    },
  },
  data() {
    return {
      votation: {},

      isLoading: true,
      imgNo: false,
    };
  },

};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/*@import '~styles/style-one';
@import '~styles/style-two';

img, Image {
  height: 20%;
  width: 20%;
  display: block;
  margin: auto;
  margin-top: 4em;

}
*/
</style>
